module.exports = __webpack_public_path__ + "img/save-info-btn.91867267.png";